

import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface, { TicketType } from '@/services/Internal-Tickets/interfaces';
import ComponentEntity, { PriorityEntity } from '@/services/Internal-Tickets/interfaces/interfaces';
import { AxiosError } from 'axios';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class AddBug extends Vue {

  public reporterId: number;
  public dialog = false;
  @Prop() ticketType: string;

  public priorities: PriorityEntity[] = [];
  public components: ComponentEntity[] = [];
  public selectedPriority = '';
  public selectedComponent = '';
  public title = '';
  public description = '';

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  public async loadComponents(): Promise<void> {
    this.components = await this.internalTicketsRepository.getComponents();
  }

  public async loadPriorities(): Promise<void> {
    this.priorities = await this.internalTicketsRepository.getPriorities();
  }

  public async reportBug(): Promise<void> {
    const dto = {
      title: this.title,
      description: this.description,
      reporter: String(this.reporterId),
      priorityId: Number(this.selectedPriority),
      componentId: Number(this.selectedComponent),
      ticketType: this.ticketType,
    };
    try {
      await this.internalTicketsRepository.createTicket(dto);
      this.$successDialog.show('Successfully added ticket');
    } catch (e) {
      if ((e as AxiosError).message !== undefined && (e as AxiosError).response !== undefined) {
        const err = e as AxiosError;
        switch (err.response?.status) {
          case 409:
            this.$errorDialog.show('Ticket with provided title already exists');
            break;
          default:
            this.$errorDialog.show('Failed to create ticket. Error: ' + err.message);
            break;
        }
      } else {
          this.$errorDialog.show('Failed to create ticket. Error: ' + (e as Error).message);
      }
    }
    this.selectedComponent = '';
    this.selectedPriority = '';
    this.title = '';
    this.description = '';
    this.dialog = false;
    this.$emit('onDialogClose');
  }

  created() {
    console.log('mounted');
    const response: any = JSON.parse(localStorage.getItem('vuex')!);
    this.reporterId = response.user.id;
  }
}
